import { call, put, select, cancelled, fork, take } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga'
import { updateStations, saveDocumentInfo } from "../actions/Stations";
import { refreshData } from "../actions/Firebase";

function createChannel(collection) {
    var un = () => { }
    return eventChannel(emit => {
      setImmediate(() => {
        un = collection.onSnapshot((snapshot) => {
          emit(snapshot);
        })
      });
      const unsubs = () => {
        un();
      }
      return unsubs;
    });
}

function* subscribeToEvent(collection, callback) {
  let channel;
  try {
    channel = yield call(createChannel, collection);
  } catch (chanErr) {
    console.tron.error(`Error creating subscription channel for event`, chanErr);
    throw chanErr;
  }

  while (true) {
    try {
      const data = yield take(channel);
      yield fork(callback, data);
    } catch (err) {
      if (yield cancelled()) {
        channel.close();
        return;
      } else {
        console.tron.error(`Error in saga task for event`, err);
      }
    }
  }
}

export function* initialize(){
    const {stationsCollection} = yield select(state => state.firebase);
    yield fork(subscribeToEvent, stationsCollection, function* (snapshot) {
        var data = [], k = 1;
        snapshot.docs.forEach((v) => {
            const obj = v.data();
            data.push({
                id: k,
                name_doc_id: v.id,
                name: `${obj.street} ${obj.street_number}, ${obj.colonia}`,
                ...obj
            })
            k++
        })
        yield put({
            type: updateStations,
            payload: data
        })
    })
    
}
//Obtiene la info de una estacion para renderizarla
export function* getDocumentInfo(action){
    const {firebase} = yield select(state => state)
    var doc_name_id = action.payload.data
    const doc = yield call([firebase.stationsCollection, firebase.stationsCollection.doc], doc_name_id);
    const docGet = yield call([doc, doc.get])
    var payload = {...docGet.data(), doc_name_id}
    yield put({type: saveDocumentInfo, payload})
}
//Actualiza la info de una estacion desde EditStation
export function* updateStation(action){
    const { stationsCollection } = yield select(state => state.firebase);
    var data = yield stationsCollection.doc(action.payload.data.actual.doc_name_id).get();
    if(data.exists){
        const pd = action.payload.data;
        var stationUpdated = {
            available: true,
            date: pd.updated.date,
            position: pd.updated.position,
            slots: pd.actual.slots,
            timestamp: Date.now()
        }
        stationsCollection.doc(pd.actual.doc_name_id).update(stationUpdated);
    }
    yield put(refreshData());
}
